import React from 'react';

interface BlockPaginationProps {
  currentPage: number;
  hasMore: boolean;
  onNextPage: () => void;
  onPrevPage: () => void;
}

export const BlockPagination: React.FC<BlockPaginationProps> = ({
  currentPage,
  hasMore,
  onNextPage,
  onPrevPage,
}) => {
  return (
    <div className="flex justify-center items-center gap-2 mt-6">
      <button
        onClick={onPrevPage}
        className="px-3 py-2 bg-primary-10 rounded-md cursor-pointer text-sm disabled:opacity-50 disabled:cursor-not-allowed"
        disabled={currentPage === 0}
      >
        <img src="/icons/arrow-right.svg" alt="previous" className="rotate-180" />
      </button>
      <span className="px-3 py-2 rounded-md bg-white text-lg font-bold">{currentPage + 1}</span>
      <button
        onClick={onNextPage}
        className="px-3 py-2 bg-primary-10 rounded-md cursor-pointer text-sm disabled:opacity-50 disabled:cursor-not-allowed"
        disabled={!hasMore}
      >
        <img src="/icons/arrow-right.svg" alt="next" />
      </button>
    </div>
  );
};

export default BlockPagination;
